<template>
  <div class="app-container">
    <basic-container>
      <el-row class="questionnaire">
        <!-- 基本信息 -->
        <el-col :span="12" v-show="currentStep === 0">
          <el-form ref="questionnaire" :model="questionnaire" label-position="top" label-width="80px" :span="16" :rules="rules" size="medium">
            <el-form-item label="问卷封面" prop="coverUrl">
              <div v-if="questionnaire.coverUrl" class="cover-url">
                <img class="cover-image" :src="questionnaire.coverUrl | ossImageProcess" v-viewer>
                <el-button type="text" @click="questionnaire.coverUrl = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
              </div>
              <el-button v-else type="text" @click="handleCoverImageChange" icon="icon-add-cover"></el-button>
              <span v-if="!questionnaire.coverUrl" style="font-size: 12px;color: #7d7d7d;display: inline-block;margin-left:4px;">(推荐尺寸为750×320像素)</span>
            </el-form-item>
            <el-form-item label="问卷名称" prop="name">
              <el-input v-model="questionnaire.name" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="问卷名称（英文）" prop="nameEn">
              <el-input v-model="questionnaire.nameEn" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="问卷描述" prop="description">
              <el-input type="textarea" v-model="questionnaire.description" maxlength="255" :rows="3" resize="none"></el-input>
            </el-form-item>
            <el-form-item label="问卷描述（英文）" prop="descriptionEn">
              <el-input type="textarea" v-model="questionnaire.descriptionEn" maxlength="255" :rows="3" resize="none"></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker type="datetime" placeholder="选择日期" v-model="questionnaire.startTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker type="datetime" placeholder="选择日期" v-model="questionnaire.endTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="问卷范围" prop="enrollScopes">
              <el-select v-model="questionnaire.enrollScopes" placeholder="问卷范围" multiple>
                <el-option
                  v-for="(item, index) in enrollScopeList"
                  :key="index"
                  :label="item.tagName"
                  :value="item.id"
                  :disabled="item.disabled">
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="匿名填写">
              <el-switch v-model="questionnaire.isAnonymous"></el-switch>
            </el-form-item>
            <el-form-item label="是否公开">
              <el-switch v-model="questionnaire.isPublic"></el-switch>
            </el-form-item>
            <el-form-item label="查看结果">
              <el-select v-model="questionnaire.viewAnswerResultType">
                <el-option v-for="(item, index) in viewAnswerResultTypeOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建人">
              <el-switch v-model="questionnaire.isShowCreator"></el-switch>
            </el-form-item> -->
            <el-form-item class="operation-basic-info">
              <el-button size="medium" @click="cancel">取消</el-button>
              <el-button size="medium" :type="isEdit ? '' : 'primary'" @click="setTopic">下一步</el-button>
              <el-button v-if="isEdit" size="medium" type="primary" @click="saveAndPublish">更新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!-- 题目 -->
        <el-col :span="12" v-show="currentStep >= 1">

          <topic-card 
            v-for="(topic, index) in questionnaire.topicList" 
            :key="index"
            :topic="topic"
            :order="index"
            :highlightTopicIndex="highlightTopicIndex"
            @hightlight="(order) => highlightTopicIndex = order"
            @topicEdit="topicEdit(index)"
            @topicCopy="topicCopy(index)"
            @topicMoveUp="topicMoveUp(index)"
            @topicMoveDown="topicMoveDown(index)"
            @topicDel="topicDel(index)"
          />

          <el-row>
            <el-col :span="20" class="btn-add-topic">
              <el-button size="medium" @click="topicAdd">添加题目</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20" class="operation-topic">
              <el-button size="medium" @click="cancel">取消</el-button>
              <el-button size="medium" @click="currentStep--">上一步</el-button>
              <el-button size="medium" type="primary" @click="saveAndPublish">{{ isEdit ? '更新' : '保存' }}</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="4">
          <el-steps :active="currentStep" direction="vertical" finish-status="success">
            <el-step title="基本信息"></el-step>
            <el-step title="题目设置"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-dialog
        :title="isEditTopic ? '题目编辑' : '题目添加'"
        v-if="topicOperationDialogVisible"
        :visible.sync="topicOperationDialogVisible"
        width="80%"
        :close-on-click-modal="false"
        :before-close="handleClose">

        <topic-editor
          ref="topic"
          :topic="topic"
        />
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="topicOperationDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="topicAddOrEdit">确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>
<script>
import { fetchEnrollScopes, createQuestionnaire, editQuestionnaire, getQuestionnaireDetail } from '@/api/app/questionnaire';
import { viewAnswerResultTypeOptions, topicTypeOptions } from '@/const/crud/app/questionnaire';
import TopicCard from '@/components/questionnaire/topic-card';
import TopicEditor from '@/components/questionnaire/topic-editor';
import _ from 'lodash';
import moment from 'moment';

export default {
  components: {
    TopicCard,
    TopicEditor,
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if(moment(this.questionnaire.endTime).diff(moment(this.questionnaire.startTime)) <= 0) {
        callback(new Error('开始时间必须小于结束时间！'));
      } else {
        callback();
      }
    };
    return {
      id: null,
      isEdit: false,
      topicTypeOptions,
      viewAnswerResultTypeOptions,
      currentStep: 0,
      highlightTopicIndex: 0,
      isEditTopic: false,
      topicOperationDialogVisible: false,
      editTopicIndex: 0,
      topic: {},
      questionnaire: {
        coverUrl: '',
        name: '',
        nameEn: '',
        description: '',
        descriptionEn: '',
        startTime: '',
        endTime: '',
        isAnonymous: false,
        isPublic: true,
        viewAnswerResultType: 1,
        isShowCreator: true,
        topicList: [],
        enrollScopes: [],
        originEnrollScopes: [],
        deleteEnrollScopes: [],
        addEnrollScopes: [],
      },
      enrollScopeList: [],
      rules: {
        coverUrl: [
          { type: 'string', required: true, message: '请选择问卷封面', trigger: 'blur' },
        ],
        name: [
          { type: 'string', required: true, message: '请输入问卷名称', trigger: 'blur' },
          { max: 50, message: '不超过50个字符', trigger: 'blur' }
        ],
        nameEn: [
          { type: 'string', required: true, message: '请输入问卷名称（英文）', trigger: 'blur' },
          { max: 50, message: '不超过50个字符', trigger: 'blur' }
        ],
        description: [
          { type: 'string', required: true, message: '请输入问卷描述', trigger: 'blur' },
          { max: 255, message: '不超过255个字符', trigger: 'blur' },
        ],
        descriptionEn: [
          { type: 'string', required: true, message: '请输入问卷描述（英文）', trigger: 'blur' },
          { max: 255, message: '不超过255个字符', trigger: 'blur' },
        ],
        startTime: [
          { type: 'string', required: true, message: '请选择开始时间', trigger: 'blur' },
          { validator: validateTime, trigger: 'change' }
        ],
        endTime: [
          { type: 'string', required: true, message: '请选择结束时间', trigger: 'blur' },
          { validator: validateTime, trigger: 'change' }
        ],
      //   enrollScopes: [
      //     { required: true, message: "请选择问卷范围" },
      //  ],
      },
    }
  },
  created() {
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    } else {
      // fetchEnrollScopes().then(response =>{
      //   if (response.data.code === 0) {
      //     this.enrollScopeList = response.data.data;
      //     this.enrollScopeList.unshift({
      //       id: -1,
      //       tagName: '全部',
      //     });
      //   } else {
      //     this.$message.error(response.msg);
      //   }
      // });
      this.draft();
    }
  },
  watch: {
    // 'questionnaire.enrollScopes': {
    //   handler(newVal, oldVal){
    //     this.controlEnrollScopeSelect(newVal, this.enrollScopeList);
    //   }
    // },
  },
  methods: {
    getDetail() {
      getQuestionnaireDetail(this.id).then(res => {
        Object.assign(this.questionnaire, res.data.data);
        this.questionnaire.topicList = this.questionnaire.topicVOList;
        delete this.questionnaire.topicVOList;
        this.questionnaire.topicList.forEach(topic => {
          topic.optionList = topic.optionVOList;
          delete topic.optionVOList;
        });
        // fetchEnrollScopes().then(response =>{
        //   if (response.data.code === 0) {
        //     this.enrollScopeList = response.data.data;
        //     this.enrollScopeList.unshift({
        //       id: -1,
        //       tagName: '所有人',
        //     });
        //     let enrollScopes = this.questionnaire.questionnaireScopeList;
        //     if (enrollScopes.length === 0) {
        //       enrollScopes = [-1];
        //     }
        //     this.questionnaire.enrollScopes = enrollScopes;
        //     this.questionnaire.originEnrollScopes = enrollScopes;
        //   } else {
        //     this.$message.error(response.data.msg);
        //   }
        // });
      }).catch(error => {
        this.$message({
          message: '获取问卷详情失败',
          type: 'error'
        })
      })
    },
    controlEnrollScopeSelect(selectedList, list) {
      if (selectedList.includes(-1)) {
        list = list.map(enrollScope => {
          enrollScope.disabled = enrollScope.id !== -1;
          return enrollScope;
        });
      } else {
        list = list.map(enrollScope => {
          enrollScope.disabled = false;
          return enrollScope;
        });
        if (selectedList.length !== 0) {
          list[0].disabled = true;
        }
      }
    },
    setTopic() {
      const currentStep = this.currentStep;
      this.$refs['questionnaire'].validate(valid => this.currentStep = !valid ? currentStep : currentStep + 1);
    },
    handleCoverImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.questionnaire.coverUrl = list[0].contentUrl;
          this.$refs['questionnaire'].validateField('coverUrl');
        }
      }, 1);
    },
    topicAddOrEdit() {
      this.$refs['topic'].validate((valid) => {
        if (valid) {
          const topicList = this.questionnaire.topicList;
          this.topic.optionList.forEach(option => {
            if (!option.score) option.score = 0;
          });
          if (!this.isEditTopic) {
            topicList.push(_.cloneDeep(this.topic));
            this.highlightTopicIndex = topicList.length - 1;
          } else {
            topicList[this.editTopicIndex] = _.cloneDeep(this.topic);
          }
          this.topic = undefined;
          this.topicOperationDialogVisible = false;
        }
      });
    },
    topicDel(index) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const topicList = this.questionnaire.topicList;

        const deletedTopicId = topicList[index].id;
        if (deletedTopicId) {
          const deleteTopicIdList = this.questionnaire.deleteTopicIdList;
          if (!deleteTopicIdList) {
            this.questionnaire.deleteTopicIdList = [deletedTopicId];
          } else {
            this.questionnaire.deleteTopicIdList.push(deletedTopicId);
          }
        }

        if (index === topicList.length - 1) {
          this.highlightTopicIndex = index - 1;
        }

        topicList.splice(index, 1);
        this.$forceUpdate();

        this.$message.success('删除成功');
      }).catch(err => {});
    },
    topicCopy(index) {
      const topicList = this.questionnaire.topicList;
      const topic = _.cloneDeep(topicList[index]);
      delete topic.id;
      topic.optionList.forEach(option => {
        delete option.id;
      });
      
      topicList.splice(index + 1, 0, topic);
      this.highlightTopicIndex = index + 1;
    },
    topicMoveUp(index) {
      const topicList = this.questionnaire.topicList;
      if (index > 0) {
        topicList[index] = topicList.splice(index - 1, 1, topicList[index])[0];
        this.highlightTopicIndex = index - 1;
      }
    },
    topicMoveDown(index) {
      const topicList = this.questionnaire.topicList;
      if (index < topicList.length - 1) {
        topicList[index] = topicList.splice(index + 1, 1, topicList[index])[0];
        this.highlightTopicIndex = index + 1;
      }
    },
    topicEdit(index) {
      this.isEditTopic = true;
      this.editTopicIndex = index;
      this.topicOperationDialogVisible = true;
      this.topic = _.cloneDeep(this.questionnaire.topicList[index]);
    },
    topicAdd() {
      this.topic = {
        name: '',
        nameEn: '',
        type: 1,
        sort: '',
        isRequired: true,
        optionList: [
          {
            description: '',
            descriptionEn: '',
            type: '',
            sort: 1,
            isAnswer: false,
            isOther: false,
          },
          {
            description: '',
            type: '',
            sort: 2,
            isAnswer: false,
            isOther: false,
          }
        ]
      };
      this.isEditTopic = false;
      this.topicOperationDialogVisible = true;
    },
    cancel () {
      const questionnaire = JSON.parse(localStorage.getItem('questionnaireDraft'))
      if (this.questionnaire.name !== '' || this.questionnaire.description !== '' || this.questionnaire.topicList.length > 0) {
        this.$confirm('是否保存为草稿?', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.saveDraf();
          this.$router.$avueRouter.closeTag();
          this.$router.go(-1);
        }).catch(err => {
          if (questionnaire) {
            localStorage.removeItem('questionnaireDraft');
          }
          if (err === 'cancel') {
            this.$router.$avueRouter.closeTag();
            this.$router.go(-1)
          }
        });
      } else {
        this.$router.$avueRouter.closeTag();
        this.$router.go(-1);
      }
    },
    saveDraf() {
      if (this.questionnaire.name !== '' || this.questionnaire.description !== '' || this.questionnaire.topicList.length > 0) {
        localStorage.setItem('questionnaireDraft', JSON.stringify(this.questionnaire));
      }
    },
    draft() {
      const questionnaire = JSON.parse(localStorage.getItem('questionnaireDraft'))
      if (questionnaire && (questionnaire.name !== '' || questionnaire.description !== '' || questionnaire.topicList.length > 0)) {
        this.$confirm('是否使用草稿?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.questionnaire = questionnaire;
        }).catch(err => {
        });
      }
    },
    generateDTO() {
      const questionnaire = _.cloneDeep(this.questionnaire);
      questionnaire.topicDTOList = questionnaire.topicList; 
      delete questionnaire.topicList;
      questionnaire.topicDTOList.forEach((topic, index) => {
        topic.sort = index + 1;
        topic.optionDTOList = topic.optionList;
        delete topic.optionList;
        topic.optionDTOList.forEach((option, optionIndex) => {
          option.sort = optionIndex + 1;
        })
      });
      if (this.isEdit) {
        questionnaire.addEnrollScopes = questionnaire.enrollScopes.filter(tag => !questionnaire.originEnrollScopes.includes(tag) && tag !== -1);
        questionnaire.deleteEnrollScopes = questionnaire.originEnrollScopes.filter(tag => !questionnaire.enrollScopes.includes(tag) && tag !== -1);
      }
      questionnaire.enrollScopes = questionnaire.enrollScopes.includes(-1) ? [] : questionnaire.enrollScopes;
      questionnaire.isPublic = questionnaire.enrollScopes.length === 0;
      return questionnaire;
    },
    saveAndPublish() {
      this.$refs['questionnaire'].validate(async valid => {
        if (!valid) {
          return;
        }
        if (this.questionnaire.topicList.length === 0) {
          return this.$message.error('问卷至少有一题');
        }
        const msgRef = this.$message({
          type: 'warning',
          duration: 0,
          message: this.isEdit ? '正在更新问卷，请稍后...' : '正在保存问卷，请稍后...'
        })
        // generate dto
        const questionnaire = this.generateDTO();

        const func = this.isEdit ? editQuestionnaire : createQuestionnaire;
        const response = await this.requestWrapper(func, questionnaire);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '操作失败, 请稍后重试',
            type: 'error',
          });
          msgRef.close();
          return;
        }
        this.$message.success(this.isEdit ? '编辑成功' : '保存成功');
        if (JSON.parse(localStorage.getItem('questionnaireDraft'))) {
          localStorage.removeItem('questionnaireDraft');
        }
        this.$router.$avueRouter.closeTag()
        this.$router.push({
          path: `/app/questionnaire`,
        });
        msgRef.close();
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item--medium .el-form-item__label {
  line-height: 15px;
}

/deep/ .el-card__body {
  padding: 45px;
}

.cover-url {
  position: relative;
  .cover-image {
    width: 100%;
  }

  .image-remove-icon {
    position: absolute;
    right: 0;
    transform: translate(50%, -50%);
  }
}

.questionnaire {
  margin-top: 32px;
}

.el-steps {
  height: 72px;
}

.btn-add-topic {
  margin: 0;
}

.operation-basic-info {
  margin: 65px 0px 25px 0px;
  text-align: right!important;
}

.operation-topic {
  text-align: right!important;
}

.btn-add-topic {
  text-align: right!important;
  margin-bottom: 20px;
}

</style>
